import * as React from 'react';

const ChatFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="chat-fill_svg__a"
                d="M15 8h-2V6h2v2zm-4 0H9V6h2v2zM7 8H5V6h2v2zm6-8H7a7 7 0 100 14h1l2 2 1.8-2H13a7 7 0 100-14z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 4)">
            <mask id="chat-fill_svg__b" fill="#fff">
                <use xlinkHref="#chat-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#chat-fill_svg__a" />
            <g mask="url(#chat-fill_svg__b)">
                <path fill="#000" d="M-2-4h24v24H-2z" />
            </g>
        </g>
    </svg>
);

ChatFillSvg.displayName = 'ChatFillSvg';
export default ChatFillSvg;
